// extracted by mini-css-extract-plugin
export default {"accordionRoot":"student-phase-accordion_accordionRoot__iDU1V"};